/** Список кук доступных на клиенте и на сервере */
const COOKIES = {
    // @deprecated Use LOCATION_V2
    LOCATION: '_SL_',
    LOCATION_V2: '_SLv2_',
    UTMZ: '__utmz',
    UUID: '.ASPXANONYMOUS',
    USER_THEME: 'userTheme',
    // Используется для установки темы системы пользователя в браузерах,
    // что не передают на сервер заголовок о желаемой цветовой теме
    SYSTEM_THEME: 'systemTheme',
};
/** Список заголовков которые могут быть прочитаны на клиенте и на сервере */
const HEADERS = {
    RETRY_AFTER: 'Retry-After',
    AUTHORIZATION: 'Authorization',
};

export { COOKIES, HEADERS };
//# sourceMappingURL=consts.js.map
